module.exports = __webpack_public_path__ + "static/img/index-xunjian.76327274.png";